const currencySymbolMapping: any = {
  EUR: '€',
  SEK: 'kr',
  DKK: 'kr.',
  CHF: 'CHF',
  GBP: '£',
};

const maximumAmountCurrency: any = {
  EUR: 99999,
  SEK: 1162498,
  DKK: 745184,
  CHF: 97784,
};

const inputIsNumber = (event: KeyboardEvent) => {
  return [
    'Backspace', 'Delete',
    '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
    'ArrowUp', 'ArrowRight', 'ArrowDown', 'ArrowLeft',
  ].indexOf(event.key) > -1;
};

const inputIsNumberWithSeparator = (event: KeyboardEvent, separator: string) => {
  return inputIsNumber(event) || event.key === separator;
};

const getCurrencySymbol = (currency: string) => {
  return currencySymbolMapping[currency] || '€';
};

const monthOptions = [
  {
    value: 1,
    label: 'onboard.1month',
  },
  {
    value: 3,
    label: 'onboard.3months',
  },
  {
    value: 6,
    label: 'onboard.6months',
  },
  {
    value: 12,
    label: 'onboard.12months',
  },
];

const refreshWhatfix = (locale: string) => {
  if (process.env.VUE_APP_WHATFIX_ENABLED === '1') {
    // @ts-ignore
    window._wfx_settings = {locale, z_index: 2};
    if (typeof((window as any)._wfx_refresh) === 'function') {
      (window as any)._wfx_refresh();
    }
  }
};

const handleErrorResponse = (error: Error, callback: () => void) => {
  callback();
};


export { inputIsNumber, inputIsNumberWithSeparator, getCurrencySymbol,
  monthOptions, refreshWhatfix, handleErrorResponse, maximumAmountCurrency };
